module.exports = __webpack_public_path__ + "static/media/gr_wide_logo_no_date.4a6077d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/gr_wide_logo_no_date.png
// module id = 560
// module chunks = 0